import $ from 'jquery';


window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

class Hamburger {
    constructor() {
        this.height = 0;
        this.activeDropdown = '';
        this.dropdowns = {};
        this.containerHeight = 0;
        this.maxDropdownHeight = 0;
    }

    setMaxDropdownHeight() {
        this.height = $('.hamburger-nav-container > .nav').outerHeight(true);
        this.maxDropdownHeight = this.height - this.containerHeight
    }
}

var hamburger = new Hamburger();

$(document).ready(() => {
    $('.menu-item-has-children > a.hamburger-dropdown-button, .menu-item-has-children > a.desktop-dropdown-button').each(function() {
        var dropdownName = $(this).text().toLowerCase();
        $(this).attr('data-name', dropdownName);
        hamburger.dropdowns[dropdownName] = { height: 0 };
    });
    $('.hamburger-nav-container > .nav > .menu-item').each(function() {
        hamburger.containerHeight += $(this).outerHeight(true);
    })
    $('.hamburger-nav-container .menu-item-has-children .sub-menu').each(function() {
        var dropdown = $(this).siblings('a').data('name');
        $(this).children().each(function() {
            hamburger.dropdowns[dropdown].height += $(this).outerHeight(true);
        });
    });
});


/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('ul.nav--header > li.menu-item-has-children').removeClass('active');
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header').toggleClass('menu-open');
    setTimeout(() => {
        hamburger.setMaxDropdownHeight();
    }, 500);

};
$('.js-menu-toggle').on('click', toggleMenu);

const toggleHamDropdowns = (event) => {
    event.preventDefault();
    var targetDropdown = $(event.target).data('name');
    if (hamburger.activeDropdown === targetDropdown) {
        $(event.target).parent().removeClass('active');
        hamburger.activeDropdown = '';
        $(event.target).siblings('.sub-menu').animate({height: 0}, 350);
    } else {
        $('ul.nav--header > li.menu-item-has-children').removeClass('active');
        if (hamburger.activeDropdown) {
            $('ul.nav--header > li.menu-item-has-children > a[data-name="' + hamburger.activeDropdown + '"]').siblings('.sub-menu').animate({height: 0}, 350);
        }
        $(event.target).parent().addClass('active');
        hamburger.activeDropdown = targetDropdown;
        var targetHeight = Math.min(hamburger.dropdowns[targetDropdown].height, hamburger.maxDropdownHeight);
        $(event.target).siblings('.sub-menu').animate({height: targetHeight}, 350);
    };
}
$('ul.nav--header > li.menu-item-has-children > a.hamburger-dropdown-button').on('click', toggleHamDropdowns);
$('ul.nav--header > li.menu-item.menu-item-has-children > a.nav-arrow').on('click', (event) => {
    event.preventDefault();
    $(event.target).parent().siblings('.hamburger-dropdown-button').click();
})

// Desktop dropdown controls 

var activeDeskDropdownID = '';
const toggleDesktopDropdowns = (event) => {
    var navContainer = $('.desktop-nav-dropdown-container');
    var targetDropdownID = $(event.target).data('name');
    var targetDropdown = $('#' + targetDropdownID);
    var dropdownHeight = $('#' + targetDropdownID).data('height');
    if (activeDeskDropdownID === targetDropdownID) {
        $(event.target).parent().removeClass('active');
        $('.nav-overlay').fadeOut(350);
        activeDeskDropdownID = '';
        navContainer.animate({height: 0}, 350);
        targetDropdown.animate({opacity: 0}, 350, function() {
            targetDropdown.css('display', 'none');
        });
    } else if (!activeDeskDropdownID) {
        $(event.target).parent().addClass('active');
        $('.nav-overlay').fadeIn(350);
        targetDropdown.css('display', 'flex');
        targetDropdown.animate({opacity: 1}, 350);
        navContainer.animate({height: dropdownHeight}, 350);
        activeDeskDropdownID = targetDropdownID;
    } else {
        var activeDropdown = $('#' + activeDeskDropdownID);
        $('ul.nav--header > li.menu-item-has-children').removeClass('active');
        $(event.target).parent().addClass('active');
        navContainer.animate({height: dropdownHeight}, 350);
        activeDropdown.animate({opacity: 0}, 350, function() {
            activeDropdown.css('display', 'none');
            targetDropdown.css('display', 'flex');
            targetDropdown.animate({opacity: 1}, 350);
        });
        activeDeskDropdownID = targetDropdownID;
    }
}
$('nav.desktop-nav-container > ul.nav--header > li.menu-item > a').on('click', toggleDesktopDropdowns);

$('.nav-overlay').on('click', (event) => {
    $(event.target).fadeOut(350);
    $('nav.desktop-nav-container > ul.nav--header > li.menu-item.active').removeClass('active');
    $('.desktop-nav-dropdown-container').animate({height: 0}, 350);

    var activeDropdown = $('#' + activeDeskDropdownID);
    activeDropdown.animate({opacity: 0}, 350, function() {
        activeDropdown.css('display', 'none');
    });
    activeDeskDropdownID = '';
})
// Filter custom posts

$('.filter-list_item').on('click', function() {
    $(this).parent().siblings().children().removeClass('active');
    $(this).addClass('active');
    var taxonomies = [];
    var filterTerms = [];
    var block = $(this).parents().eq(3);
    if (block.hasClass('has-sidebar')) {
        var postTiles = $('.posts-container > .post-tiles', block);
        $('.filter-list_item.active', $(this).parents().eq(3)).each( function() {
            $(this).data('taxonomy') ? taxonomies.push($(this).data('taxonomy')) : false;
            $(this).data('slug') ? filterTerms.push($(this).data('slug')) : false; 
        });
    } else {
        var postTiles = $(this).parent().parent().siblings('.post-tiles');
        $('.filter-list_item.active', $(this).parent()).each( function() {
            $(this).data('taxonomy') ? taxonomies.push($(this).data('taxonomy')) : false;
            $(this).data('slug') ? filterTerms.push($(this).data('slug')) : false; 
        });
    }
    var totalPosts = postTiles.data('total-posts');

    
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_custom_posts',
            filterTerms: filterTerms,
            taxonomies: taxonomies,
            postQuantity: totalPosts,
            offset: 0,
            type: $(this).data('post-type')
        },
        success: function(res) {
            postTiles.html(res);
            // $('.more-posts').show();
            $('.associated-term').on('click', filterFromAssociatedTerms);
        }
    });
});

// Trigger filters from associated category

const filterFromAssociatedTerms = (event) => {
    event.preventDefault();
    var filterSlug = $(event.target).data('slug');
    $('.filter-list_item[data-slug="' + filterSlug + '"]').click();
}
$('.associated-term').on('click', filterFromAssociatedTerms);


// Show more posts
$('.more-posts').on('click', function() {
    var postType = $(this).data('post-type');
    var taxonomies = [];
    var filterTerms = [];
    var postTiles = $(this).siblings('.post-tiles');
    if (!postTiles[0]) {
        var postTiles = $('.post-tiles', $(this).siblings('.posts-container'));
        $('.filter-list_item.active', $(this).siblings('.filters')).each( function() {
            $(this).data('taxonomy') ? taxonomies.push($(this).data('taxonomy')) : false;
            $(this).data('slug') ? filterTerms.push($(this).data('slug')) : false; 
        });
    } else {
        $('.filter-list_item.active', $(this).siblings('.filter-list')).each( function() {
            $(this).data('taxonomy') ? taxonomies.push($(this).data('taxonomy')) : false;
            $(this).data('slug') ? filterTerms.push($(this).data('slug')) : false; 
        });
    }
    
    var offset = postTiles.data('total-posts');
    var maxPosts = postTiles.data('max-posts');
    var postQuantity = postTiles.data('posts-interval');
    var postInterval = postTiles.data('posts-interval');

    postQuantity = postQuantity + offset > maxPosts ? maxPosts - offset : postQuantity;

    

    if (postQuantity < postInterval || offset === maxPosts - postInterval) {
        $(this).hide();
    }
    
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_custom_posts',
            filterTerms: filterTerms,
            taxonomies: taxonomies,
            postQuantity: postQuantity,
            offset: offset,
            type: $(this).data('post-type')
        },
        success: function(res) {
            postTiles.append(res);
            postTiles.data('total-posts', offset + postQuantity);
            $('.associated-term').on('click', filterFromAssociatedTerms);
        }
    });
});

// Show more filters
const showMoreFilters = (event, reset) => {
    event.preventDefault();
    
    var totalListItemsWidth = 0;
    var maxRows = 1;
    var filterType = $(event.target).data('filter-type');
    if (filterType) {
        var list = $('ul.filter-list.' + filterType + '-filters');
    } else {
        var list = $('ul.filter-list');
    }
    var heightMultiplier = list.data('height-multiplier');
    var listWidth = list.width();
    list.children().each( function() {
        if (totalListItemsWidth + $(this).outerWidth(true) > listWidth) {
            maxRows++;
            totalListItemsWidth = 0;
        }
        totalListItemsWidth = totalListItemsWidth + $(this).outerWidth(true);
    });

    // var currentListHeight = list.height();
    // var heightUnit = currentListHeight / heightMultiplier;

    var heightUnit = list.children().first().outerHeight(true);
    if (heightMultiplier === 1 && heightUnit < list.height()) {
        heightMultiplier = 2;
    }
    if (!reset) {
        if (maxRows - heightMultiplier === 1) {
            heightMultiplier++;
        } else {
            heightMultiplier += 2;
        }
    } else {
        heightMultiplier = maxRows > 2 ? 2 : 1;
    }

    var newListHeight = heightMultiplier * heightUnit;
    if (heightMultiplier <= maxRows) {
        list.animate({height: newListHeight}, 350, () => {
            list.data('height-multiplier', heightMultiplier);
            if (heightMultiplier === maxRows) {
                $(event.target).hide();
                if (filterType) {
                    $(event.target).siblings('.less-filters[data-filter-type=' + filterType + ']').show();
                } else {
                    $(event.target).siblings('.less-filters').show();
                }
            }
            if (reset) {
                $(event.target).hide();
                if (filterType) {
                    $(event.target).siblings('.more-filters[data-filter-type=' + filterType + ']').show();
                } else {
                    $(event.target).siblings('.more-filters').show();
                }
            }
        });
    }
}
$('a.more-filters').on('click', (event) => {
    showMoreFilters(event, false)
});
$('a.less-filters').on('click', (event) => {
    showMoreFilters(event, true)
});


// Client logo carousel
const clientsWrapper = document.querySelector('.clients-wrapper');
const clientsItems = document.querySelectorAll('.clients-wrapper > *');
const clientsLength = clientsItems.length;
const perView = 4;
if (clientsWrapper) {
    const gridGap = parseInt(getComputedStyle(clientsWrapper).columnGap, 10);
    let totalScroll = 0;
    // let autoScroll = setInterval(scrollRight, 3000);
    
    clientsWrapper.style.setProperty('--per-view', perView);
    
    for (let i = 0; i < perView; i++) {
        if (!window.mobileCheck()) {
            clientsWrapper.insertAdjacentHTML('beforeend', clientsItems[i].outerHTML);
        }
    }
    
    
    function scrollLeft(event) {
        event.preventDefault();
        totalScroll--;
        console.log(totalScroll);
        if (totalScroll == (clientsLength * -1) + 1) {
            totalScroll = 1;
            clientsWrapper.style.transition = '0s';
            clientsWrapper.style.left = 0;
        }
        const clientWidth = document.querySelector('.clients-wrapper > :first-child').offsetWidth + gridGap;

        clientsWrapper.style.left = `-${ totalScroll * clientWidth }px`;
        clientsWrapper.style.transition = '.35s';
    }
    $('.client-logos .arrow-left').on('click', scrollLeft);
    
    function scrollRight(event) {
        event.preventDefault();
        totalScroll++;
        if (totalScroll == clientsLength + 1) {
            totalScroll = 1;
            clientsWrapper.style.transition = '0s';
            clientsWrapper.style.left = 0;
        }
        const clientWidth = document.querySelector('.clients-wrapper > :first-child').offsetWidth + gridGap;
        clientsWrapper.style.left = `-${ totalScroll * clientWidth }px`;
        clientsWrapper.style.transition = '.35s';
    }
    $('.client-logos .arrow-right').on('click', scrollRight);

}